import React, { Component } from 'react';

import '../css/slide.css'

import promo1 from '../img/foto-cabecera.jpg'

class Slide extends Component {
  render() {
    return (
      <div className="cabeceratodo container">
        <div className="textocabecera row align-items-center no-gutters">
          <div className="col">
            <h1>Somos los <span className="textoresaltado">aliados</span> de tu proyecto</h1>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <img className="fotoslide img-fluid" src={promo1} alt=""/>
          </div>
        </div>
      </div>
    )
  }
}

export default Slide;
